"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signOperation = void 0;
const tx_1 = require("@ethereumjs/tx");
const eip55_1 = __importDefault(require("eip55"));
const rlp_1 = require("rlp");
const invariant_1 = __importDefault(require("invariant"));
const logs_1 = require("@ledgerhq/logs");
const hw_app_eth_1 = __importStar(require("@ledgerhq/hw-app-eth"));
const bignumber_js_1 = require("bignumber.js");
const operators_1 = require("rxjs/operators");
const rxjs_1 = require("rxjs");
const errors_1 = require("@ledgerhq/errors");
const api_1 = require("./api");
const deviceAccess_1 = require("../../hw/deviceAccess");
const nft_1 = require("../../nft");
const live_env_1 = require("@ledgerhq/live-env");
const modules_1 = require("./modules");
const transaction_1 = require("./transaction");
const logic_1 = require("./logic");
const signOperation = ({ account, deviceId, transaction, }) => (0, rxjs_1.from)(transaction.nonce !== undefined
    ? (0, rxjs_1.of)(transaction.nonce)
    : (0, api_1.apiForCurrency)(account.currency).getAccountNonce(account.freshAddress)).pipe((0, operators_1.mergeMap)(nonce => (0, deviceAccess_1.withDevice)(deviceId)(transport => new rxjs_1.Observable(o => {
    let cancelled;
    function main() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            // First, we need to create a partial tx and send to the device
            const { freshAddressPath, freshAddress } = account;
            const { gasPrice, maxFeePerGas, maxPriorityFeePerGas } = transaction;
            const gasLimit = (0, transaction_1.getGasLimit)(transaction);
            let dataMissing = !new bignumber_js_1.BigNumber(gasLimit).gt(0);
            let missingDataString = "";
            if ((0, transaction_1.EIP1559ShouldBeUsed)(account.currency)) {
                missingDataString = ` maxFeePerGas=${String(maxFeePerGas)} maxPriorityFeePerGas=${String(maxPriorityFeePerGas)}`;
                dataMissing = dataMissing && (!maxFeePerGas || !maxPriorityFeePerGas);
            }
            else {
                missingDataString = ` gasPrice=${String(gasPrice)}`;
                dataMissing = dataMissing && !gasPrice;
            }
            if (dataMissing) {
                (0, logs_1.log)("ethereum-error", `buildTransaction missingData: ${missingDataString} gasLimit=${String(gasLimit)}`);
                throw new errors_1.FeeNotLoaded();
            }
            const { ethTxObject, tx, common } = (0, transaction_1.buildEthereumTx)(account, transaction, nonce);
            const to = eip55_1.default.encode((tx.to || "").toString());
            const value = new bignumber_js_1.BigNumber("0x" + (tx.value.toString("hex") || "0"));
            // rawData Format: type 0 `rlp([nonce, gasPrice, gasLimit, to, value, data, v, r, s])`
            // EIP1559 Format: type 2 || rlp([chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, destination, amount, data, access_list, v, r, s])
            const txHex = (() => {
                if ((0, transaction_1.EIP1559ShouldBeUsed)(account.currency)) {
                    return tx.getMessageToSign(false).toString("hex");
                }
                const rawData = tx.raw();
                rawData[6] = Buffer.from((0, logic_1.padHexString)(common.chainIdBN().toString("hex")), "hex");
                return Buffer.from((0, rlp_1.encode)(rawData)).toString("hex");
            })();
            const loadConfig = {
                cryptoassetsBaseURL: (0, live_env_1.getEnv)("DYNAMIC_CAL_BASE_URL"),
            };
            if ((0, nft_1.isNFTActive)(account.currency)) {
                loadConfig.nftExplorerBaseURL = (0, live_env_1.getEnv)("NFT_ETH_METADATA_SERVICE") + "/v1/ethereum";
            }
            const m = modules_1.modes[transaction.mode];
            (0, invariant_1.default)(m, "missing module for mode=" + transaction.mode);
            const resolutionConfig = m.getResolutionConfig
                ? m.getResolutionConfig(account, transaction)
                : {};
            if (((_a = transaction.recipientDomain) === null || _a === void 0 ? void 0 : _a.type) === "forward") {
                resolutionConfig.domains = [transaction.recipientDomain];
            }
            (0, logs_1.log)("rawtx", txHex);
            const resolution = yield hw_app_eth_1.ledgerService.resolveTransaction(txHex, loadConfig, resolutionConfig);
            const eth = new hw_app_eth_1.default(transport);
            eth.setLoadConfig(loadConfig);
            o.next({ type: "device-signature-requested" });
            const result = yield eth.signTransaction(freshAddressPath, txHex, resolution);
            if (cancelled)
                return;
            o.next({ type: "device-signature-granted" });
            // Second, we re-set some tx fields from the device signature
            const v = `0x${result.v}`;
            const r = `0x${result.r}`;
            const s = `0x${result.s}`;
            const signedTx = (() => {
                if ((0, transaction_1.EIP1559ShouldBeUsed)(account.currency)) {
                    return new tx_1.FeeMarketEIP1559Transaction(Object.assign(Object.assign({}, ethTxObject), { v, r, s }), { common });
                }
                return new tx_1.Transaction(Object.assign(Object.assign({}, ethTxObject), { v, r, s }), { common });
            })();
            // Generate the signature ready to be broadcasted
            const signature = `0x${signedTx.serialize().toString("hex")}`;
            // build optimistic operation
            const txHash = ""; // resolved at broadcast time
            const senders = [freshAddress];
            const recipients = [to];
            const fee = (() => {
                if ((0, transaction_1.EIP1559ShouldBeUsed)(account.currency)) {
                    return maxFeePerGas.plus(maxPriorityFeePerGas).times(gasLimit);
                }
                return gasPrice.times(gasLimit);
            })();
            const transactionSequenceNumber = nonce;
            transaction.nonce = nonce;
            if (transaction.useAllAmount && transaction.amount.eq(0)) {
                transaction.amount = new bignumber_js_1.BigNumber(value);
            }
            const accountId = account.id;
            const editingOp = account.pendingOperations.find(op => op.transactionSequenceNumber === nonce);
            // currently, all mode are always at least one OUT tx on ETH parent
            const operation = {
                id: `${accountId}-${txHash}-OUT`,
                hash: txHash,
                transactionSequenceNumber: transactionSequenceNumber,
                type: "OUT",
                value: new bignumber_js_1.BigNumber(value),
                fee,
                blockHash: null,
                blockHeight: null,
                senders,
                recipients,
                accountId,
                date: editingOp ? editingOp.date : new Date(),
                extra: {},
                transactionRaw: (0, transaction_1.toTransactionRaw)(transaction),
            };
            m.fillOptimisticOperation(account, transaction, operation);
            o.next({
                type: "signed",
                signedOperation: {
                    operation,
                    signature,
                },
            });
        });
    }
    main().then(() => o.complete(), e => o.error(e));
    return () => {
        cancelled = true;
    };
}))));
exports.signOperation = signOperation;
//# sourceMappingURL=signOperation.js.map